/* ==========================================================================
   SCATTERED CAROUSEL — Power Section Block
   ========================================================================== */

(function () {
  'use strict';

  /* ---- Lightbox singleton ---- */

  var LIGHTBOX_ID = 'scc-lightbox-singleton';

  function getLightbox() {
    return document.getElementById(LIGHTBOX_ID);
  }

  function buildLightbox() {
    // Only ever create one lightbox, even across multiple script loads
    if (getLightbox()) return;

    var overlay = document.createElement('div');
    overlay.className = 'scc-lightbox';
    overlay.id = LIGHTBOX_ID;
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.innerHTML =
      '<div class="scc-lightbox__inner">' +
        '<button class="scc-lightbox__close" aria-label="Close lightbox">' +
          '<img src="https://cdn.shopify.com/s/files/1/0776/0153/8247/files/Icon_V2_1.png?v=1776268846" alt="" aria-hidden="true">' +
        '</button>' +
        '<img src="" alt="">' +
      '</div>';
    document.body.appendChild(overlay);
  }

  function openLightbox(src, alt) {
    var overlay = getLightbox();
    if (!overlay) return;
    overlay.querySelector('.scc-lightbox__inner > img').src = src;
    overlay.querySelector('.scc-lightbox__inner > img').alt = alt || '';
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeLightbox() {
    var overlay = getLightbox();
    if (!overlay) return;
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  function wireLightbox() {
    // Guard against duplicate listeners across multiple script loads
    if (document._sccLightboxWired) return;
    document._sccLightboxWired = true;

    document.addEventListener('click', function (e) {
      // Close button
      if (e.target.closest('.scc-lightbox__close')) {
        closeLightbox();
        return;
      }
      // Backdrop click
      if (e.target.id === LIGHTBOX_ID) {
        closeLightbox();
        return;
      }
      // Don't open a new lightbox while one is already showing
      var overlay = getLightbox();
      if (overlay && overlay.classList.contains('is-open')) return;

      // Open on image click
      var imageEl = e.target.closest('.scc-item__image');
      if (!imageEl) return;
      var img = imageEl.querySelector('img');
      if (!img) return;
      openLightbox(img.currentSrc || img.src, img.alt);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeLightbox();
    });
  }

  /* ---- Dot indicators (mobile carousel) ---- */

  function wireCarousel(root) {
    var track = root.querySelector('.scc-scattered__track');
    var dots  = root.querySelectorAll('.scc-dots span');
    var items = root.querySelectorAll('.scc-item');
    if (!track || dots.length === 0) return;
    // Avoid stacking listeners on the same track
    if (track._sccWired) return;
    track._sccWired = true;

    // Update dots on swipe — find whichever item's left edge is closest
    // to the current scroll position (robust regardless of item width/gaps)
    track.addEventListener('scroll', function () {
      var closest = 0;
      var minDist = Infinity;
      items.forEach(function (item, i) {
        var dist = Math.abs(item.offsetLeft - track.scrollLeft);
        if (dist < minDist) { minDist = dist; closest = i; }
      });
      dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i === closest);
      });
    }, { passive: true });

    // Scroll to item when dot is clicked — offsetLeft is relative to the
    // track (its offsetParent) so no maths needed
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        var target = items[i];
        if (!target) return;
        track.scrollTo({
          left: target.offsetLeft,
          behavior: 'smooth'
        });
      });
    });
  }

  function wireAllCarousels() {
    document.querySelectorAll('.scc-scattered').forEach(wireCarousel);
  }

  /* ---- Boot ---- */

  function init() {
    buildLightbox();
    wireLightbox();
    wireAllCarousels();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme editor section reload — re-wire any new carousels; lightbox is already singleton
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target.querySelector && e.target.querySelector('.scc-scattered')) {
      e.target.querySelectorAll('.scc-scattered').forEach(wireCarousel);
    }
  });

})();